import type { RunnerId } from '@ps/isp-web-services-types';

export const buildBetSlipItemId = ({ marketId, selectionId }: RunnerId) =>
  `${marketId}_${selectionId}`;
